import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import LegalLayout from "../components/legallayout"
import ContactInfo from "../components/contactinfo"

const TermsPage = () => (
  <Layout>
    <SEO title="SMS Terms and Conditions" />
    <LegalLayout>
      <h1>SMS Terms and Conditions</h1>
      <p>
        <strong>Effective Date:</strong> 05/11/2026
      </p>

      <h2>Wiltshire Jones SMS Alerts</h2>
      <p>
        By opting in to receive text messages from Wiltshire Jones ("we,"
        "us," or "our"), you agree to the following terms and conditions.
      </p>

      <h3>1. Program Description</h3>
      <p>
        When you opt in to our SMS program, you will receive text messages
        related to product launch notifications, customer service responses,
        order confirmations, account notifications, appointment reminders,
        and promotional offers and discounts.
      </p>

      <h3>2. Cancellation</h3>
      <p>
        You can cancel the SMS service at any time. Just text "STOP" to any
        message you receive from us. After you send the SMS message "STOP" to
        us, we will send you an SMS message to confirm that you have been
        unsubscribed. After this, you will no longer receive SMS messages from
        us. If you want to join again, just sign up as you did the first time
        and we will start sending SMS messages to you again.
      </p>

      <h3>3. Help</h3>
      <p>
        If you are experiencing issues with the messaging program, you can get
        help directly at support@wiltshirejones.com.
      </p>

      <h3>4. Carrier Liability</h3>
      <p>Carriers are not liable for delayed or undelivered messages.</p>

      <h3>5. Message and Data Rates</h3>
      <p>
        As always, message and data rates may apply for any messages sent to you
        from us and to us from you. You will receive messages on a recurring
        basis based on your interactions with us. If you have any questions
        about your text plan or data plan, it is best to contact your wireless
        provider.
      </p>

      <h3>6. Supported Carriers</h3>
      <p>
        Supported carriers include AT&amp;T, Verizon Wireless, T-Mobile, Sprint,
        Boost Mobile, U.S. Cellular, MetroPCS, Cricket, and most other major
        U.S. carriers. T-Mobile is not liable for delayed or undelivered
        messages. Carriers are not liable for delayed or undelivered messages.
      </p>

      <h3>7. Eligibility</h3>
      <p>
        You must be at least 18 years old (or the age of majority in your
        jurisdiction) and the account holder or authorized user of the mobile
        number you provide. By opting in, you confirm that you meet these
        requirements.
      </p>

      <h3>8. Privacy</h3>
      <p>
        For information on how we collect, use, and protect your information in
        connection with this SMS program, please review our{" "}
        <Link to="/privacy">Privacy Policy</Link>.
      </p>

      <h3>9. Changes to Terms</h3>
      <p>
        We reserve the right to modify or terminate the SMS program, or these
        terms, at any time, with or without notice. Continued participation
        after changes are posted constitutes acceptance of the updated terms.
      </p>

      <h3>10. Contact</h3>
      <p>For questions about these terms or the SMS program, contact us at:</p>
      <ContactInfo email="support@wiltshirejones.com" />
    </LegalLayout>
  </Layout>
)

export default TermsPage
